<div class="cx-one-ui" [hidden]="showDetailView || showCreateView">
    <div class="d-flex justify-content-between mx-6 mb-3 pt-3">
        <div class="font-size-24" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Manage_Metrics">Manage Metrics</div>
        <button *ngIf="permissions?.CreateAccess || (hasPMLicense != null && !hasPMLicense)" data-qa="cxone-manage-metrics-new-metric-button" type="button" class="btn btn-primary" (click)="createMetric();" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="New_Metric">New Metrics</button>
        <div class="license-required-modal-new p-3" id="PMLicenseModalNewMetric">
            <div class="mb-2 w-100 d-flex" style="color: white; align-items: center;">
                <svg class="icon-20 mr-3" style="fill:#efa716"><use href="../App_Themes/CXone/icons/modal-warning.svg#modal-warning"></use></svg>
                {{getLocalizationString("License_Required_Header", "License Required")}}
            </div>
            <div class="mb-2 w-100" style="color: white;font-size:13px;">
                {{getLocalizationString("License_Required_Body", "Performance Management license required to create metrics. Contact the system administrator. ")}}
            </div>
            <div class="d-flex">
                <button (click)="closePMLicenseModalNewMetric()" class="license-required-button mb-3 mr-3 cxone-btn btn-medium btn-primary">{{getLocalizationString("Okay", "Okay")}}</button>
            </div>
        </div>
    </div>
    <div class="bg-casper d-flex mx-6 align-items-center" style="height:60px;">
        <div id="metricCount" class="ml-4 mr-6 font-size-12">{{curMetricCount}}<span class="ml-1" data-qa="cxone-manage-metrics-metrics-count-text" cvLocalizedText
                langSection="CXOne_Manage_Metrics" langKey="Metrics">metrics</span></div>

        <div class="cxone-live-search">
            <cxone-text-input type="search" name="textInput" ngDefaultControl autocomplete="off"
                class="add-widget-search section pb-0" [placeholder]="getLocalizationString('Search_Metrics', 'Search for metrics')"
                [(ngModel)]="this.searchValue" (ngModelChangeDebounced)="searchValue"
                [ngModelChangeDebounceTime]="500" (keyup)="applyFilter()">
            </cxone-text-input>
            <i class="icon-search" [hidden]="searchValue.length !== 0">
                <svg class="icon-18 fill-iconDefault" style="position: relative; top: 5px; right: 30px; cursor: text;">
                    <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                </svg>
            </i>
            <i class="icon-search" [hidden]="searchValue.length === 0" (click)="searchValue = ''; applyFilter()">
                <svg class="icon-18 fill-iconDefault"
                    style="position: relative; top: 5px; right: 30px; cursor: pointer; transform: scale(0.8);">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </i>
        </div>
    </div>
    <div class="d-flex mx-6" style="height: calc(100vh - 160px)">
        <cv-loader [loaderType]="'cxone'" [hidden]="gridOptions != null"></cv-loader>

        <ag-grid-angular 
            #cxoneManageMetricsGrid
            [gridOptions]="gridOptions" 
            class="ag-theme-balham flex-fill"
            *ngIf="gridOptions != null"></ag-grid-angular>
    </div>
</div>

<div class="cx-one-ui mx-6 pt-3 pb-6" style="user-select: none; position:relative;" *ngIf="showDetailView">
    <div class="d-block" style="height:calc(100vh - 200px);" *ngIf="groupTypes == null">
        <cv-loader [loaderType]="'cxone'"></cv-loader>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3 cxone-fixed-header" *ngIf="groupTypes != null">
        <div>
            <div class="clickable color-cerulean font-size-12 hover-underline" cvLocalizedText
                langSection="CXOne_Manage_Metrics" langKey="Manage_Metrics" (click)="backClick();">Manage Metrics</div>
            <div class="font-size-18" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="View_Metrics">View
                Metrics</div>
        </div>
        <div class="d-flex">
            <button type="button" id="backBtn" class="btn header-btn mr-2" cvLocalizedText langSection="CXOne_Manage_Metrics"
                langKey="Back_Button" (click)="backClick();">Back</button>
            <button type="button" class="btn btn-primary" style="height: 36px; min-width: 36px;" *ngIf="(permissions?.WriteAccess || permissions?.CreateAccess || (hasPMLicense != null && !hasPMLicense))"
                    [disabled]="(selectedMetricRow == null || !selectedMetricRow.IsEditable)" (click)="previewEditClick();"
                    cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Edit">
                Edit
            </button>
            <div class="license-required-modal-edit p-3" id="PMLicenseModalEditMetric">
                <div class="mb-2 w-100 d-flex" style="color: white; align-items: center;">
                    <svg class="icon-20 mr-3" style="fill:#efa716"><use href="../App_Themes/CXone/icons/modal-warning.svg#modal-warning"></use></svg>
                    {{getLocalizationString("License_Required_Header", "License Required")}}
                </div>
                <div class="mb-2 w-100" style="color: white;font-size:13px;">
                    {{getLocalizationString("License_Required_Body_Edit", "Performance Management license required to edit metrics. Contact the system administrator")}}
                </div>
                <div class="d-flex">
                    <button (click)="closePMLicenseModalEditMetric()" class="license-required-button mb-3 mr-3 cxone-btn btn-medium btn-primary">{{getLocalizationString("Okay", "Okay")}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="content p-3 page-container" *ngIf="groupTypes != null">
        <div class="d-flex justify-content-between mb-3 pb-3 border-bottom" style="border-color:#d2d6dB;">
            <div class="d-flex align-items-center">
                <div class="font-size-16 mr-3 pr-3 border-right" style="border-color:#d2d6dB;">
                    <span class="color-theUpsideDown mr-1 font-weight-600">{{selectedMetricRow.Abreviation}}</span>
                    <span>{{"(ID " + selectedMetricRow.MetricID + ")"}}</span>
                </div>
                <div class="mr-2" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Visible_Selector">visible in selector</div>
                <cxone-slide-toggle ngbAutoFocus styleClass="small-toggle"
                    [(ngModel)]="selectedMetricRow.ShowInSelector" ngDefaultControl [disabled]="true"
                    class="align-items-center d-flex" style="height: 21px; margin-top: 2px;"></cxone-slide-toggle>
            </div>
            <div [hidden]="selectedMetricRow.Status.IsValid">
                <div class="d-flex align-items-center">
                    <svg class="icon-16 fill-redRyder">
                        <use href="../App_Themes/CXone/icons/invalid.svg#invalid"></use>
                    </svg>
                    <div class="ml-2 color-theUpsideDown font-weight-600" cvLocalizedText
                        langSection="CXOne_Manage_Metrics" langKey="Invalid">Invalid</div>
                </div>
            </div>
        </div>
        <div class="mb-4" style="width:300px;">
            <div class="color-no2Pencil font-size-12 mb-1">{{getLocalizationStringUpper("Metric_Name","Metric Name")}}
            </div>
            <cxone-text-input typeof="text" [(ngModel)]="selectedMetricRow.MetricName" data-qa="cxone-create-metric-metric-name-input" [disabled]="true"
                              [placeholder]="getLocalizationString('Metric_Name_Placeholder','Enter metric name')"></cxone-text-input>
        </div>
        <div class="mb-4">
            <div class="color-no2Pencil font-size-12 mb-1 font-weight-600">{{getLocalizationStringUpper("Description","Description")}}</div>
            <textarea class="form-control py-2" style="height:72px;width:680px;resize:none;" [disabled]="true" [(ngModel)]="selectedMetricRow.MetricDescription" placeholder="{{getLocalizationString('Metric_Description_Placeholder','Add a metric description')}}"></textarea>
        </div>
        <div class="d-flex justify-content-between mb-4" style="width:680px;">
            <div style="width:300px;">
                <div class="d-flex align-items-center mb-1">
                    <div class="color-no2Pencil font-size-12 mr-2 font-weight-600">
                        {{getLocalizationStringUpper("Employee_Hierarchy_Label","Employee Groups")}}</div>
                    <div class="align-items-center d-flex" style="height: 18px;">
                        <ng-template #employeeGroupHint><div class="text-center" style="overflow-wrap: anywhere; width: 250px;">{{getLocalizationString("EmployeeGroup_Hint","Select the lowest level employee group for the metrics.")}}</div></ng-template>
                        <svg class="icon-16 fill-iconOutline tooltipHover" [ngbPopover]="employeeGroupHint" placement="top" triggers="mouseenter:mouseleave" container="body">
                            <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                        </svg>
                    </div>
                </div>
                <cxone-singleselect-dropdown *ngIf="showDetailView"
                [ngModel]="selectedEmpValue"
                (ngModelChange)="updateEmpMin($event)"
                [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                [options]="groupTypes.emp"
                [label]="'GroupTypeName'"
                [disabled]="isDisabled">
                </cxone-singleselect-dropdown>
            </div>
            <div style="width:300px;">
                <div class="d-flex align-items-center mb-1">
                    <div class="color-no2Pencil font-size-12 mr-2 font-weight-600">{{getLocalizationStringUpper("Recording_Hierarchy_Label","Contact Groups")}}</div>
                    <div class="align-items-center d-flex" style="height: 18px;">
                        <ng-template #contactGroupHint><div class="text-center" style="overflow-wrap: anywhere; width: 250px;">{{getLocalizationString("Contact_Group_Hint","Select the lowest level contact group for the metrics.")}}</div></ng-template>
                        <svg class="icon-16 fill-iconOutline tooltipHover" [ngbPopover]="contactGroupHint" placement="top" triggers="mouseenter:mouseleave" container="body">
                            <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                        </svg>
                    </div>
                </div>
                <cxone-singleselect-dropdown *ngIf="showDetailView"
                                             [ngModel]="selectedRecValue"
                                             (ngModelChange)="updateRecMin($event)"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="groupTypes.rec"
                                             [label]="'GroupTypeName'"
                                             [disabled]="isDisabled">
                </cxone-singleselect-dropdown>
            </div>
        </div>
        <div class="mb-4" style="width:300px;">
            <div class="color-no2Pencil font-size-12 mb-1 font-weight-600">{{getLocalizationStringUpper("Category","Category")}}</div>
            <cxone-singleselect-dropdown 
                *ngIf="showDetailView" 
                                         [ngModel]="selectedCategoryValue"
                                         (ngModelChange)="updateCategory($event)"
                                         [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                         [options]="categoryOptions"
                                         [label]="'name'"
                                         [disabled]="isDisabled"
                                         id="metricCategory">
            </cxone-singleselect-dropdown>
        </div>
        <div class="mb-4">
            <div class="d-flex align-items-center">
                <!-- I'm removing a * from the preview mode but once the edit button is clicked we need to add the asterisk below this line -->
                <div *ngIf="isDisabled" class="color-no2Pencil font-size-12 mr-2 font-weight-600">
                    <span>{{getLocalizationStringUpper("Objective_Direction","Objective Direction")}}</span><span
                        class="ml-1 color-redRyder"></span></div>
                <div *ngIf="!isDisabled" class="color-no2Pencil font-size-12 mb-1 mr-2 font-weight-600">
                    <span>{{getLocalizationStringUpper("Objective_Direction","Objective Direction")}}</span><span
                        class="ml-1 color-redRyder">*</span></div>
                <div class="align-items-center d-flex" style="height: 18px;">
                    <ng-template #metricObjectiveHint><div class="text-center">{{getLocalizationString("Metric_Objective_Hint","Indicates the direction in which the metrics objective will be obtained")}}</div></ng-template>
                    <svg class="icon-16 fill-iconOutline tooltipHover" [ngbPopover]="metricObjectiveHint" triggers="mouseenter:mouseleave" placement="right" container="body">
                        <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                    </svg>
                </div>
            </div>
            <div class="d-flex">
                <cxone-radio class="radio-margin" type="radio" labelText="{{radioUpLabel}}" radioId="r1"
                             name="objectivedirection" [disabled]="isDisabled" ngDefaultControl [(ngModel)]="selectedRadioValue"
                             [value]="'1'"></cxone-radio>
                <cxone-radio class="radio-margin" type="radio" labelText="{{radioDownLabel}}" radioId="r2"
                             name="objectivedirection" [disabled]="isDisabled" [(ngModel)]="selectedRadioValue" ngDefaultControl
                             [value]="'0'"></cxone-radio>
            </div>
        </div>
        <div class="d-flex justify-content-between mb-4" style="width:680px;">
            <div style="width:300px;">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-600">{{getLocalizationStringUpper("Aggregation","Aggregation")}}</div>
                <cxone-singleselect-dropdown 
                     *ngIf="showDetailView"
                                             [ngModel]="selectedAggregationValue"
                                             (ngModelChange)="updateAggregation($event)"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="aggregationOptions"
                                             [label]="'name'"
                                             [disabled]="isDisabled"
                                             id="metricAggregation">
                </cxone-singleselect-dropdown>
            </div>
            <div style="width:300px;">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-600">{{getLocalizationStringUpper("Format_Type","Format Type")}}</div>
                <cxone-singleselect-dropdown 
                     *ngIf="showDetailView"
                                             [ngModel]="selectedFormatValue"
                                             (ngModelChange)="updateFormatType($event)"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="formatTypeOptions"
                                             [label]="'name'"
                                             [disabled]="isDisabled"
                                             id="metricFormatType">
                </cxone-singleselect-dropdown>
            </div>
        </div>
        <div class="mb-4">
            <div *ngIf="selectedMetricRow.NumericType == 3" style="width:300px;">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-600">{{getLocalizationStringUpper("Time_Format","Time Format")}}</div>
                <cxone-singleselect-dropdown [ngModel]="selectedTimeValue"
                                             (ngModelChange)="updateTimeType($event)"
                                             [placeholder]="getLocalizationString('Select...', 'Select item')"
                                             [options]="timeTypeOptions"
                                             [label]="'name'"
                                             [disabled]="true">
                </cxone-singleselect-dropdown>
            </div>
        </div>

        <div class="font-size-12 color-theUpsideDown mr-1 font-weight-bold section-header">
            {{getLocalizationStringUpper("Metric_Configuration", "Metric Configuration")}}
        </div>
        <div class="mb-3" style="color: #758994; font-size: 12px;" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Metric_Configuration_SubHeader">Set the type for all the definition in this metric</div>
        <div class="section">
            <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                {{getLocalizationStringUpper("Metric_Type","Metric Type")}}
            </div>
            <cxone-singleselect-dropdown *ngIf="showDetailView" [options]="metricTypeOptions"
                                         [ngModel]="selectedMetricType" (ngModelChange)="calculatedMetricStringSetUp()" [label]="'name'"
                                         ngDefaultControl [isRequired]="false" [disabled]="isDisabled" [search]="false"
                                         [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                         id="metricTypeDropdown"></cxone-singleselect-dropdown>
        </div>
        <div class="color-no2Pencil font-size-12 mb-1 mt-2 font-weight-bold">
            <div *ngIf="selectedMetricRow.Components.length > 1">
                {{getLocalizationStringUpper("Metric_Definition", "Metric Definition")}}
            </div>
        </div>

        <!-- Tosh's Section for single component Standard Metrics -->
        <div *ngIf="selectedMetricType.value == 2 && selectedMetricRow.Components.length == 1">
            <div class="section">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Reporting_Set","Reporting Set")}}
                    <span class="required-field" [hidden]="isDisabled">* &nbsp;</span>
                </div>
                <cxone-singleselect-dropdown *ngIf="showDetailView" [options]="reportingSetOptions"
                                             [ngModel]="reportingSetCurrent" (ngModelChange)="ChangeReportingSet($event)" [label]="'name'"
                                             [primaryKey]="'name'" ngDefaultControl [isRequired]="false" [disabled]="isDisabled"
                                             id="reportingSetDropdown"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [ngClass]="{'inputInvalid': !validationFlags.reportingSet }"></cxone-singleselect-dropdown>
            </div>
            <div class="section">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Metric_Value","Metric Value")}}
                    <ng-template #metricValueInfo>
                        <div class="text-center">
                            {{getLocalizationString("Metric_Value_Info","Metric values are dependent on selected reporting set")}}
                        </div>
                    </ng-template>
                    <span class="required-field" [hidden]="isDisabled">*</span>
                    <svg class="icon-16 fill-iconOutline center-icon ml-2" [ngbPopover]="metricValueInfo"
                         [triggers]="'hover'" [placement]="'right'" [popoverClass]="'popover-oneline'" container="body">
                        <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                    </svg>
                </div>
                <div class="d-flex">
                    <cxone-radio class="radio-margin" type="radio"
                                 labelText="{{getLocalizationStringProperSingle('Data_Field', 'Data Field')}}"
                                 (ngModelChange)="updateMetricValue()" [(ngModel)]="metricValue" ngDefaultControl
                                 radioId="m1" name="metricValue" [value]="'Data field'" [disabled]="isDisabled"></cxone-radio>
                    <cxone-radio class="radio-margin" type="radio"
                                 labelText="{{getLocalizationStringProper('Time', 'Time')}}" radioId="m2"
                                 (ngModelChange)="updateMetricValue()" [(ngModel)]="metricValue" ngDefaultControl
                                 name="metricValue" [value]="'Time'" [disabled]="isDisabled"></cxone-radio>
                    <cxone-radio class="radio-margin" type="radio"
                                 labelText="{{getLocalizationStringProper('Count', 'Count')}}" radioId="m3"
                                 (ngModelChange)="updateMetricValue()" [(ngModel)]="metricValue" ngDefaultControl
                                 name="metricValue" [value]="'Count'" [disabled]="isDisabled"></cxone-radio>

                </div>
            </div>
            <div class="d-flex">
                <div class="section dropdown-margin">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("Metric_Date","Metric Date")}}
                        <span class="required-field" [hidden]="isDisabled">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown *ngIf="showDetailView && !selectedReportingSet?.IsApiSourced" [options]="metricDateOptions"
                                                 [ngModel]="selectedMetricDate" (ngModelChange)="updateMetricStartDate($event)" [label]="'name'"
                                                 [primaryKey]="'name'" ngDefaultControl [isRequired]="false" [disabled]="isDisabled"
                                                 id="metricDateDropdown"
                                                 [search]="false"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [ngClass]="{'inputInvalid': !validationFlags.metricDate }">
                    </cxone-singleselect-dropdown>
                    <cxone-multiselect-dropdown *ngIf="showDetailView && selectedReportingSet?.IsApiSourced" [options]="metricDateOptions"
                                                [ngModel]="selectedMetricDates" (ngModelChange)="updateMetricDates($event)" [label]="'name'"
                                                [primaryKey]="'name'"  [isRequired]="false" [disabled]="isDisabled"
                                                id="metricDateDropdown"
                                                [search]="false"
                                                [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                [ngClass]="{'inputInvalid': !validationFlags.metricDate }"></cxone-multiselect-dropdown>
                </div>
                <div class="section" *ngIf="metricValue == 'Data field' && !selectedReportingSet?.IsApiSourced">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("Data_Value","Data Value")}}
                        <span class="required-field" [hidden]="isDisabled">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown *ngIf="showDetailView" [options]="dataValueOptions"
                                                 [ngModel]="selectedDataValue" (ngModelChange)="updateMetricDataValue($event)" [label]="'name'"
                                                 [primaryKey]="'name'" ngDefaultControl [isRequired]="false" [disabled]="isDisabled"
                                                 id="metricValueDropdown"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [ngClass]="{'inputInvalid': !validationFlags.metricDataValue }"></cxone-singleselect-dropdown>
                </div>
                <div class="section dropdown-margin" *ngIf="selectedReportingSet?.IsApiSourced">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("Default_Date","Default Date")}}
                        <span class="required-field" [hidden]="isDisabled">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown *ngIf="showDetailView" [options]="defaultDateOptions"
                                                 [ngModel]="selectedDefaultDate" (ngModelChange)="updateMetricStartDate($event)" [label]="'name'"
                                                 [primaryKey]="'name'" ngDefaultControl [isRequired]="false" [disabled]="isDisabled"
                                                 id="metricDefaultDropdown"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [ngClass]="{'inputInvalid': !validationFlags.metricDataValue }"></cxone-singleselect-dropdown>
                </div>
                <div class="section" *ngIf="metricValue == 'Time' && !selectedReportingSet?.IsApiSourced">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("End_Date","End Date")}}
                        <span class="required-field" [hidden]="isDisabled">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown *ngIf="showDetailView" [options]="metricDateOptions"
                                                 [ngModel]="selectedEndDate" (ngModelChange)="updateMetricEndDate($event)" [label]="'name'"
                                                 [primaryKey]="'name'" ngDefaultControl [isRequired]="false" [disabled]="isDisabled"
                                                 [search]="false" id="metricValueDropdown"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [ngClass]="{'inputInvalid': !validationFlags.metricEndDate }"></cxone-singleselect-dropdown>
                </div>
            </div>
            <div class="section" *ngIf="metricValue == 'Data field' && selectedReportingSet?.IsApiSourced">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Data_Value","Data Value")}}
                    <span class="required-field" [hidden]="isDisabled">* &nbsp;</span>
                </div>
                <cxone-singleselect-dropdown *ngIf="showDetailView" [options]="dataValueOptions"
                                             [ngModel]="selectedDataValue" (ngModelChange)="updateMetricDataValue($event)" [label]="'name'"
                                             [primaryKey]="'name'" ngDefaultControl [isRequired]="false" [disabled]="isDisabled"
                                             id="metricValueDropdown"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [ngClass]="{'inputInvalid': !validationFlags.metricDataValue }"></cxone-singleselect-dropdown>
            </div>
            <div class="section" *ngIf="metricValue == 'Time' && selectedReportingSet?.IsApiSourced">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("End_Date","End Date")}}
                    <span class="required-field" [hidden]="isDisabled">* &nbsp;</span>
                </div>
                <cxone-singleselect-dropdown *ngIf="showDetailView" [options]="metricDateOptions"
                                             [ngModel]="selectedEndDate" (ngModelChange)="updateMetricEndDate($event)" [label]="'name'"
                                             [primaryKey]="'name'" ngDefaultControl [isRequired]="false" [disabled]="isDisabled"
                                             [search]="false" id="metricValueDropdown"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [ngClass]="{'inputInvalid': !validationFlags.metricEndDate }"></cxone-singleselect-dropdown>
            </div>
            <div class="section">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Filter_Fields","Filter Fields")}}
                    <span class="required-field" [hidden]="isDisabled">*</span>
                    <span>&nbsp;</span>
                    <ng-template #filterFieldsInfo>
                        <div class="text-center">
                            {{getLocalizationString("Filter_Fields_Info","Populate the mandatory fields to add filters")}}
                        </div>
                    </ng-template>
                    <svg class="icon-16 fill-iconOutline center-icon" [ngbPopover]="filterFieldsInfo"
                         [triggers]="'hover'" [placement]="'right'" [popoverClass]="'popover-oneline'" container="body">
                        <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                    </svg>
                </div>
                <div [ngClass]="{'section': selectedMetricRow.Components[0].FilterFields.length > 0}" >
                    <button class="cxone-btn btn-big btn-secondary" (click)="OpenFilterModal()" [disabled]="isDisabled || !AddFilterButtonIsValid()"
                            cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Add_Filters"></button>
                </div>
                <div *ngIf="selectedMetricRow.Components[0].FilterFields.length > 0" class="filterFieldsContainer">
                    <div *ngFor="let field of selectedMetricRow.Components[0].FilterFields; let count = index; let first = first;">
                        <div>
                            <div *ngIf="!first" class="add-line"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Component_Multiple_Filters_AND">AND</span></div>
                            <div class="font-weight-bold">
                                {{getLocalizationString("Filter", "Filter") + " " + (count + 1)}}
                            </div>
                            <br />
                            <div class="metric-definition-text data-visualization-green">
                        {{field.EvalField}} <span class="data-visualization-pink">{{getComparisonOperator(field.ComparisonType)}} </span> <span
                            class="text-dark"
                            *ngFor="let val of field.CompValues; let last = last">{{parseCompValue(CheckIfNumber(val))}}<span
                                class="text-dark" *ngIf="!last">,</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Tosh's Section for the multiple component Standard Metrics -->
        <div id="MetricDefinitionSection"
             *ngIf="selectedMetricType.value == 2 && selectedMetricRow.Components.length > 1">
            <cxone-embedded-messages class="old-metric-message" messageType="user-warning" [messageData]="this.localization.get('Old_Metric_Warning')"></cxone-embedded-messages>
            <div *ngFor="let comp of selectedMetricRow.Components; let first = first">
                <fieldset class="cxone-fieldset d-flex">
                    <legend *ngIf="!first" align="center" class="cxone-legend" >
                        {{comp.IsPositive ? localizationCommon.get("Add").toUpperCase() :
                        localizationCommon.get("Subtract").toUpperCase()}}</legend>
                    <div class="component-header">
                        <div class="metric-definition-text" *ngIf="comp.ReportingSetName"><span cvLocalizedText
                                langSection="Pipeline_Configuration" langKey="Reporting_Set_Name">Reporting Set
                                Name</span><span>:</span></div>
                        <div class="metric-definition-text" *ngIf="comp.StartDate"><span cvLocalizedText
                                langSection="Pipeline_Configuration" langKey="Start_Date">Start
                                Date</span><span>:</span></div>
                        <div class="metric-definition-text" *ngIf="comp.DataValue"><span cvLocalizedText
                                langSection="Pipeline_Configuration" langKey="Data_Value">Data
                                Value</span><span>:</span></div>
                        <div class="metric-definition-text" *ngIf="comp.FilterFields.length > 0"><span cvLocalizedText
                                langSection="Pipeline_Configuration" langKey="Component_Filter_Fields">Filter
                                Fields</span><span>:</span></div>
                        </div>
                    <div>
                        <div class="metric-definition-text" *ngIf="comp.ReportingSetName">{{comp.ReportingSetName}}
                        </div>
                        <div class="metric-definition-text" *ngIf="comp.StartDate">{{comp.StartDate}}</div>
                        <div class="metric-definition-text" *ngIf="comp.DataValue">{{comp.DataValue}}</div>
                        <div class="metric-definition-text" *ngIf="comp.FilterFields.length > 0"><span
                                *ngFor="let field of comp.FilterFields;  last as fLast;"
                                class="data-visualization-green">{{field.EvalField}} = <span
                                    *ngFor="let values of field.CompValues;  last as vLast;"
                                    class="text-dark">"{{parseCompValue(values)}}"<span class="text-dark" *ngIf="!vLast || !fLast">,
                                        &nbsp;</span></span> </span></div>
                        </div>
                </fieldset>
            </div>
        </div>

        <!-- Riley's Section for the Calculated Metric -->
        <div *ngIf="selectedMetricType.value == 1" class="row m-0 calculatedContainer" style="height: 100px;">
            <div class="textAreaCalculatedMetric"></div>
            <div class="form-control py-2" id="CalculatedMetricDefinition" [innerHTML]="calculatedMetricHTML"
                 style="width:100%;resize:none; height:100%;border: none;"></div>
        </div>
        <!-- Metric Assignments -->
        <div>
            <div class="d-flex justify-content-between mb-2 pb-2 border-bottom section-header" style="border-color:#d2d6dB;">
                <span class="font-size-12 color-theUpsideDown mr-1 font-weight-bold">{{getLocalizationStringUpper("Assignments","Assignments")}}</span>
            </div>
            <div class="mb-3 font-size-12" style="color: #758994;" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Assigned_To_Company">Metrics are assigned to the company by default, but you can choose another contact group.</div>
            <cxone-omnibar [itemCountLabel]="assignmentsLabel" [isFilterable]="false"
                           [searchPlaceholderText]="assignmentsSearchPlaceholder"
                           (searchQueryChange)="onAssignmentsFilterChange($event)">
            </cxone-omnibar>
            <ag-grid-angular 
                #cxoneManageMetricsAssignmentsGrid
                             *ngIf="assignmentsGridOptions != null"
                             [gridOptions]="assignmentsGridOptions"
                             [ngClass]="assignmentsSize"
                             class="assignmentsGrid cx-one-ui ag-theme-balham cxone-grid flex-fill">
            </ag-grid-angular>
        </div>
    </div>
</div>

<!-- This is the Create Metric Section -->
<div class="cx-one-ui mx-6 pt-3 pb-6" style="user-select: none; position: relative;" *ngIf="showCreateView">
    <div class="d-block" style="height:calc(100vh - 200px);" *ngIf="groupTypes == null || showSpinner">
        <cv-loader [loaderType]="'cxone'"></cv-loader>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-3 cxone-fixed-header" *ngIf="groupTypes != null && !showSpinner">
        <div>
            <div *ngIf="selectedMetricRow.MetricID == 0" class="clickable color-cerulean font-size-12" cvLocalizedText
                langSection="CXOne_Manage_Metrics" langKey="Manage_Metrics" (click)="confirmCancel();">Manage Metrics
            </div>
            <div *ngIf="selectedMetricRow.MetricID != 0" class="clickable color-cerulean font-size-12" cvLocalizedText
                langSection="CXOne_Manage_Metrics" langKey="Manage_Metrics" (click)="confirmCancel();">Manage Metrics
            </div>
            <div *ngIf="!isDuplicate" class="font-size-18" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Create_Metric">Create
                Metric</div>
            <div *ngIf="isDuplicate" class="font-size-18" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Duplicate_Metric">Duplicate
                Metric</div>
            </div>
        <div class="d-flex">
            <button *ngIf="selectedMetricRow.MetricID == 0" id="backBtn" type="button" class="btn header-btn mr-2" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Back_Button" (click)="confirmCancel();">Back</button>
            <button *ngIf="selectedMetricRow.MetricID != 0" type="button" class="btn header-btn mr-2 btn-secondary btn-bg-is-white" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Cancel" (click)="confirmCancel();">Cancel</button>
            <button *ngIf="selectedMetricRow.MetricID == 0" id="createBtn" type="button" class="btn-big cxone-btn btn-primary" (click)="saveClicked();" [disabled]="!isMetricChanged()" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Create">Create</button>
            <button *ngIf="selectedMetricRow.MetricID != 0" type="button" class="btn-big cxone-btn btn-primary" (click)="saveClicked();" [disabled]="!isMetricChanged() || (isRecalculationModalOpen)" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Save_And_Update">Save and Update</button>
        </div>
    </div>

    <div *ngIf="isEditingDisabled && !isNewMetric">
        <cv-embedded-messages messageType="system-warning" [messageData]="recalculationInProgressMessage"
                              [messageLink]="moreDetailsMessage" (linkClicked)="openModal()">
        </cv-embedded-messages>
    </div>

    <div *ngIf="!isEditingDisabled && !isNewMetric && groupTypes != null && !showSpinner">
        <ng-container *ngIf="recalculationStatusMessage">
            <cv-embedded-messages messageType="system-info" *ngIf="isStandardMetric && isMetricAvailable && hideCompletedMessage"
                                  [messageData]="recalculationCompleteMessage" [messageLink]="moreDetailsMessage" (linkClicked)="openModal()">
            </cv-embedded-messages>
            <cv-embedded-messages messageType="system-warning"
                                  [messageData]="editWarningString" id="warning-msg">
            </cv-embedded-messages>
        </ng-container>
        <cv-embedded-messages *ngIf="!recalculationStatusMessage" messageType="system-warning"
                              [messageData]="editWarningString" id="warning-msg">
        </cv-embedded-messages>
    </div>

    <div class="content p-3 page-container"
        [ngStyle]="{ 'height': selectedMetricRow.MetricID != 0 ? 'calc(100vh - 146px)' : '' }" style="border-radius: 0px" *ngIf="groupTypes != null && !showSpinner">
        <div class="d-flex justify-content-between mb-3 pb-3 border-bottom" style="border-color:#d2d6dB;">
            <div class="d-flex align-items-center">
                <div class="mr-2" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Visible_Selector">visible
                    in selector</div>
                <cxone-slide-toggle ngbAutoFocus styleClass="small-toggle" class="align-items-center d-flex"
                                    style="height: 21px; margin-top: 2px;"
                                    slideOnColor="#007CBE"
                                    [disabled]="isEditingDisabled"
                                    [(ngModel)]="selectedMetricRow.ShowInSelector"></cxone-slide-toggle>
            </div>
            <div [hidden]="selectedMetricRow.Status.IsValid">
                <div class="d-flex align-items-center">
                    <svg class="icon-16 fill-redRyder">
                        <use href="../App_Themes/CXone/icons/invalid.svg#invalid"></use>
                    </svg>
                    <div class="ml-2 color-theUpsideDown font-weight-bold" cvLocalizedText
                         langSection="CXOne_Manage_Metrics" langKey="Invalid">Invalid</div>
                </div>
            </div>
        </div>
        <div class="mb-4">
            <div class="color-no2Pencil font-size-12 mb-1 font-weight-600">
                <span>{{getLocalizationStringUpper("Metric_Name","Metric Name")}}</span>
                <span class="ml-1" style="color:#CE313F">*</span>
            </div>
            <div style="width:300px;">
                <cxone-text-input typeof="text" [(ngModel)]="selectedMetricRow.MetricName" data-qa="cxone-create-metric-metric-name-input"
                [disabled]="isEditingDisabled"
                    (ngModelChange)="metricNameChanged($event)" [required]="true"
                [ngClass]="{'inputInvalid': !validationFlags.nameUnique || !validationFlags.nameLength || !validationFlags.nameChars }"
                [placeholder]="getLocalizationString('Metric_Name_Placeholder','Enter metric name')">
                </cxone-text-input>
            </div>
            <div *ngIf="!validationFlags.nameUnique" style="color:#CE313F; font-size:12px;" cvLocalizedText
                 langSection="CXOne_Manage_Metrics" langKey="Invalid_Metric_Name">Metric name already exists</div>
            <div *ngIf="!validationFlags.nameLength" style="color: #CE313F; font-size: 12px;" cvLocalizedText
                langSection="CXOne_Manage_Metrics" langKey="Invalid_Metric_Length">This entry cannot exceed 30
                characters</div>
            <div *ngIf="!validationFlags.nameChars" style="color: #CE313F; font-size: 12px;" cvLocalizedText
                langSection="CXOne_Manage_Metrics" langKey="Invalid_Metric_Character">These characters are not supported
                + / * <> = ^ : ( )</div>
            </div>
        <div class="mb-4">
            <div class="color-no2Pencil font-size-12 mb-1 font-weight-600">{{getLocalizationStringUpper("Description","Description")}}</div>
            <textarea class="form-control py-2"
                      style="height:72px;width:680px;resize:none;"
                      placeholder="{{getLocalizationString('Metric_Description_Placeholder','Add a metric description')}}"
                      [(ngModel)]="selectedMetricRow.MetricDescription"
                      (ngModelChange)="validateMetricDescription();triggerCancelConfirm();"
                      [disabled]="isEditingDisabled"
                      [ngClass]="{'inputInvalid': !validationFlags.description }"></textarea>
            <div *ngIf="!validationFlags.description" style="color: #CE313F; font-size: 12px;" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Invalid_Description_Length">This entry cannot exceed 1000 characters</div>
        </div>
        <div class="d-flex justify-content-between mb-4" style="width:680px;">
            <div style="width:300px;">
                <div class="d-flex align-items-center mb-1">
                    <div class="color-no2Pencil font-size-12 mr-2 font-weight-600">
                        {{getLocalizationStringUpper("Employee_Hierarchy_Label","Employee Groups")}}
                    </div>
                    <div class="align-items-center d-flex" style="height: 18px;">
                        <ng-template #employeeGroupHint><div class="text-center" style="overflow-wrap: anywhere; width: 250px;">{{getLocalizationString("EmployeeGroup_Hint","Select the lowest level employee group for the metrics.")}}</div></ng-template>
                        <svg class="icon-16 fill-iconOutline tooltipHover" [ngbPopover]="employeeGroupHint" triggers="mouseenter:mouseleave" placement="top" container="body"><use href="../App_Themes/CXone/icons/info.svg#info"></use></svg>
                    </div>
                </div>
                <cxone-singleselect-dropdown 
                    *ngIf="showCreateView" 
                                             [primaryKey]="'GroupLevel'"
                                             [ngModel]="selectedEmpValue"
                                             (ngModelChange)="updateEmpMin($event);triggerCancelConfirm();"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="groupTypes.emp"
                                             [sortKey]="'GroupLevel'"
                                             [label]="'GroupTypeName'"
                                             [search]="false"
                                             [isRequired]="true"
                                             [showFooter]="false"
                                             [disabled]="isEditingDisabled">
                </cxone-singleselect-dropdown>
            </div>
            <div style="width:300px;">
                <div class="d-flex align-items-center mb-1">
                    <div class="color-no2Pencil font-size-12 mr-2 font-weight-600">
                        {{getLocalizationStringUpper("Recording_Hierarchy_Label","Contact Groups")}}
                    </div>
                    <div class="align-items-center d-flex" style="height: 18px;">
                        <ng-template #contactGroupHint><div class="text-center" style="overflow-wrap: anywhere; width: 250px;">{{getLocalizationString("Contact_Group_Hint","Select the lowest level contact group for the metrics.")}}</div></ng-template>
                        <svg class="icon-16 fill-iconOutline tooltipHover" [ngbPopover]="contactGroupHint" placement="top" triggers="mouseenter:mouseleave" container="body"><use href="../App_Themes/CXone/icons/info.svg#info"></use></svg>
                    </div>
                </div>
                <cxone-singleselect-dropdown 
                    *ngIf="showCreateView" 
                                             [primaryKey]="'GroupLevel'"
                                             [ngModel]="selectedRecValue"
                                             (ngModelChange)="updateRecMin($event);triggerCancelConfirm();"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="groupTypes.rec"
                                             [sortKey]="'GroupLevel'"
                                             [label]="'GroupTypeName'"
                                             [search]="false"
                                             [isRequired]="true"
                                             [showFooter]="false"
                                             [disabled]="isEditingDisabled">
                </cxone-singleselect-dropdown>
            </div>
        </div>
        <div class="mb-4" style="width:300px;">
            <div class="color-no2Pencil font-size-12 mb-1">
                <span class="font-weight-600">{{getLocalizationStringUpper("Category","Category")}}</span>
                <span class="ml-1" style="color:#CE313F">*</span>
            </div>
            <cxone-singleselect-dropdown *ngIf="showCreateView"
                                         [ngModel]="selectedCategoryValue"
                                         (ngModelChange)="updateCategory($event);validateCategory();triggerCancelConfirm();"
                                         [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                         [options]="categoryOptions"
                                         [label]="'name'"
                                         [primaryKey]="'name'"
                                         [isRequired]="true"
                                         [enableAddFreeTextItem]="true"
                                         [disabled]="isEditingDisabled"
                                         id="metricCategory"
                                         (onCreate)="addCategoryOption($event)">
            </cxone-singleselect-dropdown>
            <div *ngIf="!validationFlags.category && selectedMetricRow.Group.length > 50"
                 style="color: #CE313F; font-size: 12px;" cvLocalizedText langSection="CXOne_Manage_Metrics"
                 langKey="Invalid_Category_Length">This entry cannot exceed 50 characters</div>
        </div>
        <div class="mb-4">
            <div class="d-flex align-items-center">
                <div class="color-no2Pencil font-size-12 mr-2 font-weight-600">
                    <span>{{getLocalizationStringUpper("Objective_Direction","Objective Direction")}}</span>
                    <span class="ml-1" style="color:#CE313F">*</span>
                </div>
                <div class="align-items-center d-flex" style="height: 18px;">
                    <ng-template #metricObjectiveHint><div class="text-center">{{getLocalizationString("Metric_Objective_Hint","Indicates the direction in which the metrics objective will be obtained")}}</div></ng-template>
                    <svg class="icon-16 fill-iconOutline tooltipHover" [ngbPopover]="metricObjectiveHint" triggers="mouseenter:mouseleave" placement="right" container="body"><use href="../App_Themes/CXone/icons/info.svg#info"></use></svg>
                </div>
            </div>
            <div class="d-flex">
                <cxone-radio class="mr-4" type="radio" labelText="{{radioUpLabel}}" radioId="r1"
                             name="objectivedirection" [(ngModel)]="selectedRadioValue" [disabled]="isEditingDisabled"
                             (ngModelChange)="updateRadioValue($event);triggerCancelConfirm();" [value]="'1'"></cxone-radio>
                <cxone-radio type="radio" labelText="{{radioDownLabel}}" radioId="r2" name="objectivedirection"
                             [(ngModel)]="selectedRadioValue" (ngModelChange)="updateRadioValue($event);triggerCancelConfirm();"
                             [value]="'0'" [disabled]="isEditingDisabled"></cxone-radio>
            </div>
        </div>
        <div class="d-flex justify-content-between mb-4" style="width:680px;">
            <div style="width:300px;">
                <div class="color-no2Pencil font-size-12 mb-1">
                    <span class="font-weight-600">{{getLocalizationStringUpper("Aggregation","Aggregation")}}</span>
                    <span class="ml-1" style="color:#CE313F">*</span>
                </div>
                <cxone-singleselect-dropdown 
                    *ngIf="showCreateView" 
                                             [primaryKey]="'value'"
                                             [ngModel]="selectedAggregationValue"
                                             (ngModelChange)="updateAggregation($event);triggerCancelConfirm();"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="aggregationOptions"
                                             [label]="'name'"
                                             [showFooter]="false"
                                             [search]="false"
                                             [disabled]="isDisabled || isEditingDisabled"
                                             id="metricAggregation">
                </cxone-singleselect-dropdown>
            </div>
            <div style="width:300px;">
                <div class="color-no2Pencil font-size-12 mb-1">
                    <span class="font-weight-600">{{getLocalizationStringUpper("Format_Type","FormatType")}}</span>
                    <span class="ml-1" style="color:#CE313F">*</span>
                </div>
                <cxone-singleselect-dropdown 
                     [primaryKey]="'value'"
                                             [ngModel]="selectedFormatValue"
                                             (ngModelChange)="updateFormatType($event);triggerCancelConfirm();"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="formatTypeOptions"
                                             [label]="'name'"
                                             [showFooter]="false"
                                             [search]="false"
                                             [disabled]="isEditingDisabled"
                                             id="metricFormatType">
                </cxone-singleselect-dropdown>
            </div>
        </div>
        <div class="mb-4">
            <div *ngIf="selectedMetricRow.NumericType == 3" style="width:300px;">
                <div class="color-no2Pencil font-size-12 mb-1">
                    <span class="font-weight-600">{{getLocalizationStringUpper("Time_Format","Time Format")}}</span>
                    <span class="ml-1" style="color:#CE313F">*</span>
                </div>
                <cxone-singleselect-dropdown 
                     [primaryKey]="'value'"
                                             [ngModel]="selectedTimeValue"
                                             (ngModelChange)="updateTimeType($event);triggerCancelConfirm();"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [options]="timeTypeOptions"
                                             [label]="'name'"
                                             [showFooter]="false"
                                             [search]="false"
                                             [disabled]="isEditingDisabled">
                </cxone-singleselect-dropdown>
            </div>
        </div>

        <div class="section-header">{{getLocalizationStringUpper("Metric_Configuration", "Metric Configuration")}}</div>
        <div class="mb-3" style="color: #758994; font-size: 12px;" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Metric_Configuration_SubHeader">Set the type for all the definition in this metric</div>
        <div style="width:300px;">
            <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                {{getLocalizationStringUpper("Metric_Type","Metric Type")}}
                <span class="ml-1" style="color:#CE313F">*</span>
            </div>
            <cxone-singleselect-dropdown *ngIf="showCreateView"
                                         [options]="metricTypeOptions"
                                         [ngModel]="selectedMetricType"
                                         (ngModelChange)="createSelectChange($event);triggerCancelConfirm();"
                                         [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                         [label]="'name'"
                                         [primaryKey]="'name'"
                                         [isRequired]="false"
                                         [showFooter]="false"
                                         [disabled]="isDisabled || isEditingDisabled"
                                         [search]="false"
                                         id="metricTypeDropdown">
            </cxone-singleselect-dropdown>
        </div>
        <div class="color-no2Pencil font-size-12 mb-1 mt-4 font-weight-bold">
            <div *ngIf="selectedMetricRow.Components.length > 1">
                {{getLocalizationStringUpper("Metric_Definition", "Metric Definition")}}
            </div>
        </div>
        <!-- Riley's Section for the Calculated Metric Creation -->
        <sol-inline-notification class="formulaWarning" *ngIf="showCalculated && (!validationFlags.formulaEmpty || !validationFlags.formulaSpecialCharacter ||
            !validationFlags.formulaOperator || !validationFlags.formulaMissingMetric || !validationFlags.formulaInvalidMetric || !validationFlags.formulaInvalid || !validationFlags.rootMetricBeingUsedInFormula)"
                                 [type]="'error'" [show]="true" [showClose]="false" [message]="getFormulaValidationErrorMessage()" id="system-error"> </sol-inline-notification>
        <sol-inline-notification *ngIf="showCalculated && formulaIsValid" [type]="'success'" [show]="true" [showClose]="false" [message]="getLocalizationString('Valid_Formula', 'Formula is valid')"></sol-inline-notification>
        <!-- <sol-inline-notification type="success" message="Formula is valid"></sol-inline-notification> -->
        <div class="editCalculatedContainer row m-0" *ngIf="showCalculated">
            <div class="metricsButton d-flex align-items-center pl-3">
                <button class="btn btn-primary" type="button" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Metrics"
                style="height: 28px;min-width: 79px;" (click)="toggleMetricSelector()">Metrics</button>
                <button class="btn btn-primary ml-3" type="button" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Validate"
                style="height: 28px;min-width: 79px;" [disabled]="validateEnableBtn()" (click)="validateBtn()">Validate</button>
            </div>
            <div class="formula d-flex">
                <div class="tinyMceEditor overflow-hidden w-100 h-100" style="margin-right: -8px;">
                    <editor 
                        class="editor" 
                        [(ngModel)]="calculatedMetricModel" 
                        [init]="{ 
                            content_style: 'cxone-manage-metrics.component.scss', 
                            height: 235, 
                            width: '100%', 
                            border: 0, 
                            selector: 'textarea', 
                            menubar: false, 
                            branding: false, 
                            statusbar: false, 
                            paste_data_images: false,
                            image_list: [],
                            media_list: [],
                            paste_block_drop: true,
                            paste_preprocess: contextualColorPrePaste,
                            smart_paste: false,
                            forced_root_block: 'p',
                            force_br_newlines: false,
                            toolbar: false,
                            entity_encoding: 'raw',
                            invalid_elements: 'em, br, h1, h2, h3',
                            extended_valid_elements : 'span[class|style|id|onclick|contenteditable]',
                            base_url: '../dist/angular/tinymce',
                            suffix: '.min',
                            setup: setUpTinyMCE,
                        }">

                    </editor>
                </div>
            </div>
            <div class="operators py-2 pl-3">
                <p style="font-size: 12px; color: #758994" class="mb-2">{{getLocalizationStringUpper("Operators", "Operators")}}</p>
                <div class="operatorsContainer">
                    <div class="addOperator d-flex operatorItems" (click)="calculatedMetricConcat(0)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 4px;">+</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Addition">Addition</p>
                    </div>
                    <div class="subOperator d-flex operatorItems" (click)="calculatedMetricConcat(1)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 2px;">-</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Subtraction">Subtraction</p>
                    </div>
                    <div class="multiplyOperator d-flex operatorItems" (click)="calculatedMetricConcat(2)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 8px;">*</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Multiplication">Multiplication</p>
                    </div>
                    <div class="divideOperator d-flex operatorItems" (click)="calculatedMetricConcat(3)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 4px;">/</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Division">Division</p>
                    </div>
                    <div class="greaterOperator d-flex operatorItems" (click)="calculatedMetricConcat(4)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 6px;">></span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Greater_Than">Greater Than</p>
                    </div>
                    <div class="lessOperator d-flex operatorItems" (click)="calculatedMetricConcat(5)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 6px;">&lt;</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Less_Than">Less Than</p>
                    </div>
                    <div class="equalOperator d-flex operatorItems" (click)="calculatedMetricConcat(6)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 5px;">=</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Equals_To">Equals To</p>
                    </div>
                    <div class="modulusOperator d-flex operatorItems" (click)="calculatedMetricConcat(7)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 6px;">%</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Modulus">Modulus</p>
                    </div>
                    <div class="powerOperator d-flex operatorItems" (click)="calculatedMetricConcat(8)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 7px;">^</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Power">Power</p>
                    </div>
                    <div class="ratioOperator d-flex operatorItems" (click)="calculatedMetricConcat(9)">
                        <p class="operatorAlignment"><span class="operatorColor" style="margin-top: 2px;">:</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Ratio">Ratio</p>
                    </div>
                    <div class="paranOperator d-flex operatorItems" (click)="calculatedMetricConcat(10)">
                        <p class="operatorAlignment"><span class="operatorColor">()</span></p>
                        <p cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Parentheses">Parentheses</p>
                    </div>
                </div>
            </div>
            <div class="functions py-2 px-3">
                <p style="font-size: 12px; color: #758994" class="mb-2">{{getLocalizationStringUpper("Functions", "Functions")}}</p>
                <div class="operatorsContainer">
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(11)">
                        <p class="functionColor">abs(x)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(12)">
                        <p class="functionColor">sqrt(x)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(13)">
                        <p class="functionColor">rem(x,n)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(14)">
                        <p class="functionColor">pow(x,n)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(15)">
                        <p class="functionColor">log(x)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(16)">
                        <p class="functionColor">round(x)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(17)">
                        <p class="functionColor">truncate(x)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(18)">
                        <p class="functionColor">floor(x)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(19)">
                        <p class="functionColor">ceiling(x)</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(20)">
                        <p class="functionColor">TOTx</p>
                    </div>
                    <div class="d-flex operatorItems" (click)="calculatedMetricConcat(21)">
                        <p class="functionColor">PREVx</p>
                    </div>
                </div>
            </div>
            <div class="variables py-2 px-3">
                <p style="font-size: 12px; color: #758994" class="mb-2">{{getLocalizationStringUpper("Variables", "Variables")}}</p>
                <div class="d-flex operatorItems " (click)="calculatedMetricConcat(22)">
                    <p class="variableColor mb-0">&#10100;NUMDAYS&#10101;</p>
                </div>
            </div>
            <div class="templates py-2 px-3">
                <p style="font-size: 12px; color: #758994" class="mb-2">{{getLocalizationStringUpper("Templates", "Templates")}}</p>
                <div class="operatorsContainer">
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(23)">
                        <p>m1 + m2</p>
                    </div>
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(24)">
                        <p>m1 + m2 + m3</p>
                    </div>
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(25)">
                        <p>(m1 + m2) / m3</p>
                    </div>
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(26)">
                        <p>(m1 + m2) * m3</p>
                    </div>
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(27)">
                        <p>(m1 + m2) * n</p>
                    </div>
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(28)">
                        <p>m1 / m2</p>
                    </div>
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(29)">
                        <p>m1 / (m1 + m3)</p>
                    </div>
                    <div class="d-flex operatorItems pb-2" (click)="calculatedMetricConcat(30)">
                        <p>m1 * m2</p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectedMetricType?.value == 2 && selectedMetricRow.Components.length == 1">
            <div class="section">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Reporting_Set","Reporting Set")}}
                    <span class="required-field">* &nbsp;</span>
                </div>
                <cxone-singleselect-dropdown [options]="reportingSetOptions" [ngModel]="reportingSetCurrent"
                                             (ngModelChange)="ChangeReportingSet($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'" ngDefaultControl
                                             [isRequired]="false" id="reportingSetDropdown"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [disabled]="isEditingDisabled"
                                             [ngClass]="{'inputInvalid': this.selectedReportingSet && this.metricDateOptions.length == 0}"></cxone-singleselect-dropdown>
                <div class="font-size-12" style="color:#CE313F">
                    <span *ngIf="this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="No_Data_Found">No data found.</span>
                </div>
            </div>
            <div class="section">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Metric_Value","Metric Value")}}
                    <ng-template #metricValueInfo>
                        <div class="text-center">
                            {{getLocalizationString("Metric_Value_Info","Metric values are dependent on selected reporting set")}}
                        </div>
                    </ng-template>
                    <span class="required-field">*</span>
                    <svg class="icon-16 fill-iconOutline center-icon ml-2" [ngbPopover]="metricValueInfo"
                         [triggers]="'hover'" [placement]="'right'" [popoverClass]="'popover-oneline'" container="body">
                        <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                    </svg>
                </div>
                <div class="d-flex">
                    <cxone-radio class="radio-margin" type="radio"
                                 labelText="{{getLocalizationStringProperSingle('Data_Field', 'Data Field')}}"
                                 (ngModelChange)="updateMetricValue();triggerCancelConfirm();" [(ngModel)]="metricValue" ngDefaultControl
                                 radioId="m1" name="metricValue" [value]="'Data field'" [disabled]="isEditingDisabled"></cxone-radio>
                    <cxone-radio class="radio-margin" type="radio"
                                 labelText="{{getLocalizationStringProper('Time', 'Time')}}" radioId="m2"
                                 (ngModelChange)="updateMetricValue();triggerCancelConfirm();" [(ngModel)]="metricValue" ngDefaultControl
                                 name="metricValue" [value]="'Time'" [disabled]="isEditingDisabled"></cxone-radio>
                    <cxone-radio class="radio-margin" type="radio"
                                 labelText="{{getLocalizationStringProper('Count', 'Count')}}" radioId="m3"
                                 (ngModelChange)="updateMetricValue();triggerCancelConfirm();" [(ngModel)]="metricValue" ngDefaultControl
                                 name="metricValue" [value]="'Count'" [disabled]="isEditingDisabled"></cxone-radio>
                </div>
            </div>
            <div class="d-flex">
                <div class="section dropdown-margin">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("Metric_Date","Metric Date")}}
                        <span class="required-field">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown [options]="metricDateOptions" [ngModel]="selectedMetricDate" *ngIf="!selectedReportingSet?.IsApiSourced"
                                                 (ngModelChange)="updateMetricStartDate($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'"
                                                 ngDefaultControl [isRequired]="false" id="metricDateDropdown"
                                                 [search]="metricDateOptions.length > 10"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [showFooter]="metricDateOptions.length > 10"
                        [disabled]="(this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)) || isEditingDisabled" >
                    </cxone-singleselect-dropdown>
                    <cxone-multiselect-dropdown [options]="metricDateOptions" [ngModel]="selectedMetricDates" *ngIf="selectedReportingSet?.IsApiSourced"
                                                (ngModelChange)="updateMetricDates($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'"
                                                ngDefaultControl [isRequired]="false" id="metricDateDropdown"
                                                [search]="metricDateOptions.length > 10"
                                                [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                [showFooter]="metricDateOptions.length > 10"
                    [disabled]="(this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)) || isEditingDisabled" ></cxone-multiselect-dropdown>
                </div>
                <div class="section" *ngIf="metricValue == 'Data field' && !selectedReportingSet?.IsApiSourced">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("Data_Value","Data Value")}}
                        <span class="required-field">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown [options]="dataValueOptions" [ngModel]="selectedDataValue"
                                                 (ngModelChange)="updateMetricDataValue($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'"
                                                 ngDefaultControl [isRequired]="false" id="metricValueDropdown"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [showFooter]="dataValueOptions.length > 10"
                                                 [search]="dataValueOptions.length > 10" [disabled]="(this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)) || isEditingDisabled"></cxone-singleselect-dropdown>
                </div>
                <div class="section dropdown-margin" *ngIf="selectedReportingSet?.IsApiSourced">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("Default_Date","Default Date")}}
                        <span class="required-field">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown [options]="defaultDateOptions" [ngModel]="selectedDefaultDate"
                                                 (ngModelChange)="updateMetricStartDate($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'"
                                                  [isRequired]="false" id="metricDefaultDropdown"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [showFooter]="selectedMetricDates.length > 10"
                                                 [search]="selectedMetricDates.length > 10" [disabled]="(this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)) || isEditingDisabled || defaultDateOptions.length == 0"></cxone-singleselect-dropdown>
                </div>
                <div class="section" *ngIf="metricValue == 'Time' && !selectedReportingSet?.IsApiSourced">
                    <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                        {{getLocalizationStringUpper("End_Date","End Date")}}
                        <span class="required-field">* &nbsp;</span>
                    </div>
                    <cxone-singleselect-dropdown [options]="metricDateOptions" [ngModel]="selectedEndDate"
                                                 (ngModelChange)="updateMetricEndDate($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'"
                                                 ngDefaultControl [isRequired]="false" [search]="false" id="metricValueDropdown"
                                                 [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                                 [showFooter]="metricDateOptions.length > 10"
                                                 [search]="metricDateOptions.length > 10"
                                                 [disabled]="(this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)) || isEditingDisabled"></cxone-singleselect-dropdown>
                </div>
            </div>
            <div class="section" *ngIf="metricValue == 'Data field' && selectedReportingSet?.IsApiSourced">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Data_Value","Data Value")}}
                    <span class="required-field">* &nbsp;</span>
                </div>
                <cxone-singleselect-dropdown [options]="dataValueOptions" [ngModel]="selectedDataValue"
                                             (ngModelChange)="updateMetricDataValue($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'"
                                              [isRequired]="false" id="metricValueDropdown"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [showFooter]="dataValueOptions.length > 10"
                                             [search]="dataValueOptions.length > 10" [disabled]="(this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)) || isEditingDisabled"></cxone-singleselect-dropdown>
            </div>
            <div class="section" *ngIf="metricValue == 'Time' && selectedReportingSet?.IsApiSourced">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("End_Date","End Date")}}
                    <span class="required-field">* &nbsp;</span>
                </div>
                <cxone-singleselect-dropdown [options]="metricDateOptions" [ngModel]="selectedEndDate"
                                             (ngModelChange)="updateMetricEndDate($event);triggerCancelConfirm();" [label]="'name'" [primaryKey]="'name'"
                                             ngDefaultControl [isRequired]="false" [search]="false" id="metricValueDropdown"
                                             [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                             [showFooter]="metricDateOptions.length > 10"
                                             [search]="metricDateOptions.length > 10"
                                             [disabled]="(this.selectedReportingSet && (this.metricDateOptions.length == 0 || this.dataValueOptions.length == 0)) || isEditingDisabled"></cxone-singleselect-dropdown>
            </div>
            <div class="section w-100">
                <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                    {{getLocalizationStringUpper("Filter_Fields","Filter Fields")}}
                    <span>&nbsp;</span>
                    <ng-template #filterFieldsInfo>
                        <div class="text-center">
                            {{getLocalizationString("Filter_Fields_Info","Populate the mandatory fields to add filters")}}
                        </div>
                    </ng-template>
                    <svg class="icon-16 fill-iconOutline center-icon" [ngbPopover]="filterFieldsInfo"
                         [triggers]="'hover'" [placement]="'right'" [popoverClass]="'popover-oneline'" container="body">
                        <use href="../App_Themes/CXone/icons/info.svg#info"></use>
                    </svg>
                </div>
                <div class="d-flex" [ngClass]="{'section': selectedMetricRow.Components[0].FilterFields.length > 0}">
                    <button class="cxone-btn btn-big btn-secondary btn-bg-is-white" (click)="OpenFilterModal()" [disabled]="!AddFilterButtonIsValid() || isEditingDisabled" cvLocalizedText
                    cvLocalizedText  langSection="CXOne_Manage_Metrics" langKey="Add_Filters"></button>
                    <button class="edit-filters-link" (click)="OpenFilterModal()" [ngStyle]="getEditFilterStyling()" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Edit_Filters" [disabled]="(!AddFilterButtonIsValid() || selectedMetricRow.Components[0].FilterFields.length == 0) || isEditingDisabled">Edit Filters</button>
                </div>
                <div *ngIf="selectedMetricRow.Components[0].FilterFields.length > 0" class="filterFieldsContainer">
                    <div *ngFor="let field of selectedMetricRow.Components[0].FilterFields; let count = index; let first = first">
                        <div>
                            <div *ngIf="!first" class="add-line"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Component_Multiple_Filters_AND">AND</span></div>
                            <div class="d-flex">
                                <div class="font-weight-bold text-nowrap">
                                    {{getLocalizationString("Filter", "Filter") + " " + (count + 1)}}
                                </div>
                                <div style="margin-left:96%" [popoverClass]="'cxoneFilterDeletePopover'" [ngbPopover]="deleteFilterPopover"
                                     triggers="manual" container="body" placement="left" #p="ngbPopover" (click)="ActivatePopover(p)"
                                    [class.icon-disabled]="isEditingDisabled"><svg class="icon-16 cursor-hover fillTrash">
                                        <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                                    </svg>
                                </div>
                            </div>
                            <br />
                            <div class="metric-definition-text data-visualization-green">
                            {{field.EvalField}} <span class="data-visualization-pink">{{getComparisonOperator(field.ComparisonType)}} </span> <span
                                class="text-dark"
                                *ngFor="let val of field.CompValues; let last = last">{{parseCompValue(CheckIfNumber(val))}}<span
                                    class="text-dark" *ngIf="!last">,</span></span>
                            </div>
                        </div>
                        <ng-template #deleteFilterPopover>
                            <div>
                                <div class="popoverText" cvLocalizedText langSection="CXOne_Manage_Metrics" langKey="Delete_Filter_Popover">
                                    Delete this filter?
                                </div>
                                <div class="confirmBtns">
                                    <button type="button" class="cxone-btn btn-medium btn-popover" style="margin-right: 10px; width: fit-content;">
                                        <span cvLocalizedText langSection="Dashboards_Landing" langKey="Cancel_Button"
                                              style="margin-top: 4px;">Cancel</span>
                                    </button>
                                    <button type="button" (click)="deleteFilterField(count)" class="cxone-btn btn-medium btn-primary"
                                            style="position: relative; top: 3px; width: fit-content;">
                                        <span cvLocalizedText langSection="Dashboards_Landing" langKey="Delete_Button">Delete</span>
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>

            </div>

        </div>
        <!-- Metric Assignments -->
        <div>
            <div class="d-flex justify-content-between mb-2 pb-2 border-bottom section-header" style="border-color:#d2d6dB;">
                <span class="font-size-12 color-theUpsideDown mr-1 font-weight-bold">{{getLocalizationStringUpper("Assignments","Assignments")}}</span>
            </div>
            <div class="mb-3" style="color: #758994; font-size: 12px;">{{getLocalizationString("Assigned_To_Company","Metrics are assigned to the company by default, but you can choose another contact group.")}}</div>
            <cxone-omnibar [itemCountLabel]="assignmentsLabel"
                           [isFilterable]="false"
                           [searchPlaceholderText]="assignmentsSearchPlaceholder"
                           (searchQueryChange)="onAssignmentsFilterChange($event)">
                <cxone-omnibar-custom-content style="width: 73px; height: 28px; margin-left: auto;">
                    <div style="display: flex; justify-content: flex-end; margin-right: 22.5px">
                        <button class="assign-btns btn btn-secondary" style="margin-right: 8px;"
                     [disabled]="(!(agGridAssignments?.api) || agGridAssignments.api.getSelectedRows().length == 0) || isEditingDisabled" (click)="removeSelectedAssignments()">{{getLocalizationString("Remove_Button_Text","Remove")}}</button>
                        <button class="assign-btns btn btn-primary" (click)="openAssignTool()" [disabled]="isEditingDisabled">{{getLocalizationString("Assign","Assign")}}</button>
                    </div>
                </cxone-omnibar-custom-content>
            </cxone-omnibar>
        <ag-grid-angular 
            #cxoneManageMetricsAssignmentsGrid
                             *ngIf="assignmentsGridOptions != null"
                             [gridOptions]="assignmentsGridOptions"
                             [ngClass]="assignmentsSize"
                             class="assignmentsGrid cx-one-ui ag-theme-balham cxone-grid flex-fill">
            </ag-grid-angular>
        </div>
    </div>
</div>

<ng-template #metricModal>
    <cv-associated-metrics [metricList]="this.assocMetricList" [SelectedMetric]="selectedMetric" (close)="CloseModal()"></cv-associated-metrics>
</ng-template>

<ng-template #filterFields>
    <cv-filter-fields-edit (updateFilterFields)="editFilterFieldsAddClick($event)" [reportingSet]="selectedReportingSet" [filterFields]="selectedMetricRow.Components[0].FilterFields" [metricDate]="selectedReportingSet?.IsApiSourced ? selectedDefaultDate.name : selectedMetricDate.name"
                           (close)="CloseModal()"></cv-filter-fields-edit>
</ng-template>
